import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { fetchCleanerSectionShell } from "@/lib/fetchCleanerSectionShell";
import { areCleanerShellQueryParamsReady } from "@/lib/cleanerQueryGuards";
import { cleanerTasksQueryKey } from "@/lib/cleanerQueryKeys";

const STALE_MS = 1000 * 60 * 5;
const GC_MS = 1000 * 60 * 30;

export function useCleanerSectionShell(
  propertyId: string | undefined,
  sectionId: string | undefined,
  orgId: string | undefined
) {
  const shellQueryReady = areCleanerShellQueryParamsReady(propertyId, sectionId, orgId);

  return useQuery({
    queryKey: cleanerTasksQueryKey(propertyId, sectionId, orgId),
    queryFn: () => {
      if (!sectionId || sectionId === "undefined" || sectionId === "null") {
        throw new Error("Zablokowano zapytanie z błędnym ID (undefined).");
      }
      return fetchCleanerSectionShell(propertyId!, sectionId!, orgId!);
    },
    enabled: shellQueryReady,
    retry: 1,
    staleTime: STALE_MS,
    gcTime: GC_MS,
    refetchOnMount: "always",
    placeholderData: keepPreviousData,
  });
}
